// @flow
export const EXTERNAL_FLOW_START: string = 'EXTERNAL_FLOW_START';
